module.exports = __webpack_public_path__ + "static/eth-rocket-9604e533a8bf35da17ac2317b497cb06.jpg";